<template>
	<div>
		<myheader headTitle="在线签约存证信息"></myheader>
		<div class="header_extend_main" style="padding-bottom: .5rem;">
			<div class="header_extend_back" style="height: 6rem;"></div>
			<div class="header_extend_content">
				<div class="all_tips_content_card">
					<div class="text12 textcolor333">
						声明：区块链存证数据以及相关服务由长城链提供技术支持，长城链网址：https://gwc.sinopec.com。</div>
				</div>
				<div v-if="type === '1'">
					<div class="all_tips_content_card margin_top_10">
						<div class="text14 textcolor999">上传文件信息</div>
						<div class="horizontal_line margin_top_2"></div>
						<div
							v-if="$store.state.certificateVerificationInfo.bcResult&&$store.state.certificateVerificationInfo.bcResult.upload">
							<div class="margin_top_2">
								<span class="text12 textcolor999" style="display: inline-block; width: 25%;">文件名称</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.bcResult.upload.fileName}}</span>
							</div>
							<div class="margin_top_1">
								<span class="text12 textcolor999" style="display: inline-block; width: 25%;">文件大小</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.bcResult.upload.fileSize +' kb'}}</span>
							</div>
							<div class="margin_top_1">
								<span class="text12 textcolor999" style="display: inline-block; width: 25%;">上传时间</span>
								<span class="text12 textcolor999">
									{{ getDateArrayToString($store.state.certificateVerificationInfo.bcResult.upload.uploadTime)}}
								</span>
							</div>
							<div>
								<span class="text12 textcolor999" style="display: inline-block; width: 25%;">合同哈希</span>
								<div style="display: inline-block;width: 75%;">
									<span class="text12 textcolormain all_auto_wrap" style="display: block;">
										{{$store.state.certificateVerificationInfo.bcResult.upload.fileHash}}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="all_tips_content_card margin_top_10">
						<div class="text12 textcolor999">合同上链信息</div>
						<div class="horizontal_line margin_top_2"></div>
						<!-- <div class="horizontal_line margin_top_2" style="margin-bottom: .1rem;"></div> -->
						<!-- <div v-for="item in $store.state.certificateVerificationInfo.bcResult.evidenceData" :key="item">
						<div class="margin_top_1" v-if="item.title!='合同ID'">
							<span class="text12 textcolor999" style="display: inline-block; width: 25%;">{{item.title}}</span>
							<span class="text12 textcolor999">{{item.value}}</span>
						</div>
					</div> -->
						<div
							v-if="$store.state.certificateVerificationInfo.bcResult&&$store.state.certificateVerificationInfo.bcResult.evidenceData">
							<div class="margin_top_2 display_flex"
								v-if="$store.state.certificateVerificationInfo.bcResult.evidenceData.contractName">
								<span class="text12 textcolor999" style="display: inline-block; width: 25%;">合同名称</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.bcResult.evidenceData.contractName.value}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.bcResult.evidenceData.contractCode">
								<span class="text12 textcolor999" style="display: inline-block; width: 25%;">合同编号</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.bcResult.evidenceData.contractCode.value}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.bcResult.evidenceData.corpName">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 25%;">合同签约单位</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.bcResult.evidenceData.corpName.value}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.bcResult.evidenceData.fileSize">
								<span class="text12 textcolor999" style="display: inline-block; width: 25%;">合同大小</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.bcResult.evidenceData.fileSize.value+' kb'}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.bcResult.evidenceData.contractState">
								<span class="text12 textcolor999" style="display: inline-block; width: 25%;">签约状态</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.bcResult.evidenceData.contractState.value}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.bcResult.evidenceData.completeName">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 25%;">{{$store.state.certificateVerificationInfo.bcResult.evidenceData.completeName.title}}</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.bcResult.evidenceData.completeName.value}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.bcResult.evidenceData.completeCode">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 25%;">{{$store.state.certificateVerificationInfo.bcResult.evidenceData.completeCode.title}}</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.bcResult.evidenceData.completeCode.value}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.bcResult.evidenceData.completeTime">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 25%;">{{$store.state.certificateVerificationInfo.bcResult.evidenceData.completeTime.title}}</span>
								<span
									class="text12 textcolor999">{{getDateArrayToString($store.state.certificateVerificationInfo.bcResult.evidenceData.completeTime.value)}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.bcResult.evidenceData.cancelName">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 25%;">{{$store.state.certificateVerificationInfo.bcResult.evidenceData.cancelName.title}}</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.bcResult.evidenceData.cancelName.value}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.bcResult.evidenceData.cancelCode">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 25%;">{{$store.state.certificateVerificationInfo.bcResult.evidenceData.cancelCode.title}}</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.bcResult.evidenceData.cancelCode.value}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.bcResult.evidenceData.cancelTime">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 25%;">{{$store.state.certificateVerificationInfo.bcResult.evidenceData.cancelTime.title}}</span>
								<span
									class="text12 textcolor999">{{getDateArrayToString($store.state.certificateVerificationInfo.bcResult.evidenceData.cancelTime.value)}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.bcResult.evidenceData.cancelDesc">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 25%;">{{$store.state.certificateVerificationInfo.bcResult.evidenceData.cancelDesc.title}}</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.bcResult.evidenceData.cancelDesc.value}}</span>
							</div>
							<div v-if="$store.state.certificateVerificationInfo.bcResult.evidenceData.fileHash">
								<span class="text12 textcolor999" style="display: inline-block; width: 25%;">合同哈希</span>
								<div style="display: inline-block;width: 75%;">
									<span class="text12 textcolormain all_auto_wrap" style="display: block;">
										{{$store.state.certificateVerificationInfo.bcResult.evidenceData.fileHash.value}}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="all_tips_content_card margin_top_10">
						<div class="text12 textcolor999">区块信息</div>
						<div class="horizontal_line margin_top_2"></div>
						<div class="margin_top_2" v-if="$store.state.certificateVerificationInfo.bcResult.evidenceCode">
							<span class="text12 textcolor999" style="display: inline-block; width: 30%;">长城链存证编号</span>
							<div style="display: inline-block;width: 70%;">
								<span class="text12 textcolormain all_auto_wrap" style="display: block;">
									{{$store.state.certificateVerificationInfo.bcResult.evidenceCode}}</span>
							</div>
						</div>
						<div class="margin_top_1" v-if="$store.state.certificateVerificationInfo.evidenceTime">
							<span class="text12 textcolor999" style="display: inline-block; width: 30%;">长城链存证时间</span>
							<span
								class="text12 textcolor999">{{ getDateArrayToString($store.state.certificateVerificationInfo.evidenceTime)}}</span>
						</div>
						<div class="margin_top_1" v-if="$store.state.certificateVerificationInfo.bcResult.evidenceBch">
							<span class="text12 textcolor999" style="display: inline-block; width: 30%;">长城链区块高度</span>
							<span
								class="text12 textcolor999">{{$store.state.certificateVerificationInfo.bcResult.evidenceBch}}</span>
						</div>
					</div>
					<div v-if="$store.state.certificateVerificationInfo.caResult.items.length>0"
						class="all_tips_content_card margin_top_10">
						<div class="text12 textcolor999">CA存证信息</div>
						<div class="text12 textcolor3300FF margin_top_2">
							{{'电子合同中共包含'+$store.state.certificateVerificationInfo.caResult.items.length+'个电子签名'}}
						</div>
					</div>
					<div v-for="item in $store.state.certificateVerificationInfo.caResult.items">
						<div class="all_tips_content_card margin_top_10">
							<div class="text12 textcolorblack">签约信息</div>
							<div class="margin_top_1">
								<span class="text12 textcolor999" style="display: inline-block; width: 30%;">签约人</span>
								<span class="text12 textcolor999">{{ item.subject}}</span>
							</div>
							<div class="margin_top_1">
								<span class="text12 textcolor999" style="display: inline-block; width: 30%;">签约时间</span>
								<span class="text12 textcolor999">{{ getDateArrayToString(item.signDate)}}</span>
							</div>
							<div class="margin_top_1">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 30%;">签约时间来源</span>
								<span class="text12 textcolor999">国家授时中心</span>
							</div>
							<div class="text12 textcolorblack margin_top_10">证书信息</div>
							<div class="margin_top_1">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 30%;">证书序列号</span>
								<span class="text12 textcolor999">{{ item.serialNumber}}</span>
							</div>
							<div class="margin_top_1">
								<span class="text12 textcolor999" style="display: inline-block; width: 30%;">颁发机构</span>
								<span class="text12 textcolor999">{{ item.issuer }}</span>
							</div>
							<div class="margin_top_1">
								<span class="text12 textcolor999" style="display: inline-block; width: 30%;">截止时间</span>
								<span class="text12 textcolor999">{{ getDateArrayToString(item.expireDate)}}</span>
							</div>
						</div>
					</div>
				</div>
				<div v-if="type === '0'">
					<div class="all_tips_content_card margin_top_10">
						<div class="text12 textcolor999">区块链存证信息</div>
						<div class="horizontal_line margin_top_2"></div>
						<div v-if="$store.state.certificateVerificationInfo.evidenceData">
							<div class="margin_top_2"
								v-if="$store.state.certificateVerificationInfo.evidenceData.contractName">
								<span class="text12 textcolor999" style="display: inline-block; width: 25%;">合同名称</span>
								<span class="text12 textcolor999"
									style="display: inline-block; width: 75%;">{{$store.state.certificateVerificationInfo.evidenceData.contractName.value}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.evidenceData.contractCode">
								<span class="text12 textcolor999" style="display: inline-block; width: 25%;">合同编号</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.evidenceData.contractCode.value}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.evidenceData.corpName">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 25%;">合同签约单位</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.evidenceData.corpName.value}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.evidenceData.fileSize">
								<span class="text12 textcolor999" style="display: inline-block; width: 25%;">合同大小</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.evidenceData.fileSize.value+' kb'}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.evidenceData.contractState">
								<span class="text12 textcolor999" style="display: inline-block; width: 25%;">签约状态</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.evidenceData.contractState.value}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.evidenceData.completeName">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 25%;">{{$store.state.certificateVerificationInfo.evidenceData.completeName.title}}</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.evidenceData.completeName.value}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.evidenceData.completeCode">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 25%;">{{$store.state.certificateVerificationInfo.evidenceData.completeCode.title}}</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.evidenceData.completeCode.value}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.evidenceData.completeTime">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 25%;">{{$store.state.certificateVerificationInfo.evidenceData.completeTime.title}}</span>
								<span
									class="text12 textcolor999">{{getDateArrayToString($store.state.certificateVerificationInfo.evidenceData.completeTime.value)}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.evidenceData.cancelName">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 25%;">{{$store.state.certificateVerificationInfo.evidenceData.cancelName.title}}</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.evidenceData.cancelName.value}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.evidenceData.cancelCode">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 25%;">{{$store.state.certificateVerificationInfo.evidenceData.cancelCode.title}}</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.evidenceData.cancelCode.value}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.evidenceData.cancelTime">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 25%;">{{$store.state.certificateVerificationInfo.evidenceData.cancelTime.title}}</span>
								<span
									class="text12 textcolor999">{{getDateArrayToString($store.state.certificateVerificationInfo.evidenceData.cancelTime.value)}}</span>
							</div>
							<div class="margin_top_1"
								v-if="$store.state.certificateVerificationInfo.evidenceData.cancelDesc">
								<span class="text12 textcolor999"
									style="display: inline-block; width: 25%;">{{$store.state.certificateVerificationInfo.evidenceData.cancelDesc.title}}</span>
								<span
									class="text12 textcolor999">{{$store.state.certificateVerificationInfo.evidenceData.cancelDesc.value}}</span>
							</div>
							<div v-if="$store.state.certificateVerificationInfo.evidenceData.fileHash">
								<span class="text12 textcolor999" style="display: inline-block; width: 25%;">合同哈希</span>
								<div style="display: inline-block;width: 75%;">
									<span class="text12 textcolormain all_auto_wrap" style="display: block;">
										{{$store.state.certificateVerificationInfo.evidenceData.fileHash.value}}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="all_tips_content_card margin_top_10">
						<div class="text12 textcolor999">区块信息</div>
						<div class="horizontal_line margin_top_2"></div>
						<div class="margin_top_2" v-if="$store.state.certificateVerificationInfo.evidenceCode">
							<span class="text12 textcolor999" style="display: inline-block; width: 30%;">长城链存证编号</span>
							<div style="display: inline-block;width: 70%;">
								<span class="text12 textcolormain all_auto_wrap" style="display: block;">
									{{$store.state.certificateVerificationInfo.evidenceCode}}</span>
							</div>
						</div>
						<div class="margin_top_1" v-if="$store.state.certificateVerificationInfo.evidenceTime">
							<span class="text12 textcolor999" style="display: inline-block; width: 30%;">长城链存证时间</span>
							<span
								class="text12 textcolor999">{{getDateArrayToString($store.state.certificateVerificationInfo.evidenceTime)}}</span>
						</div>
						<div class="margin_top_1" v-if="$store.state.certificateVerificationInfo.evidenceBch">
							<span class="text12 textcolor999" style="display: inline-block; width: 30%;">长城链区块高度</span>
							<span
								class="text12 textcolor999">{{$store.state.certificateVerificationInfo.evidenceBch}}</span>
						</div>
					</div>
				</div>
				<div v-if="type === '2'" class="all_tips_content_card margin_top_10">
					<div class="text14 textcolor999">上传文件信息</div>
					<div class="horizontal_line margin_top_2"></div>
					<div v-if="certificateVerificationInfo">
						<div class="margin_top_2">
							<span class="text12 textcolor999" style="display: inline-block; width: 25%;">文件名称</span>
							<span class="text12 textcolor999">{{certificateVerificationInfo.fileName ||'-'}}</span>
						</div>
						<div class="margin_top_1">
							<span class="text12 textcolor999" style="display: inline-block; width: 25%;">文件大小</span>
							<span class="text12 textcolor999">{{certificateVerificationInfo.fileSize +' kb'}}</span>
						</div>
						<div class="margin_top_1">
							<span class="text12 textcolor999" style="display: inline-block; width: 25%;">上传时间</span>
							<span class="text12 textcolor999">
								{{ Tool.dateFormate(certificateVerificationInfo.uploadTime)||'-'}}
							</span>
						</div>
						<div>
							<span class="text12 textcolor999" style="display: inline-block; width: 25%;">合同哈希</span>
							<div style="display: inline-block;width: 75%;">
								<span class="text12 textcolormain all_auto_wrap" style="display: block;">
									{{certificateVerificationInfo.fileHash||'-'}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="all_tips_content_card margin_top_10">
					<div class="text12 textcolorblack">上链信息</div>
					<div v-for="(item,index) in evidenceKeys" :key="index">
						<div class="margin_top_1">
							<span class="text12 textcolor999"
								style="display: inline-block; width: 30%;">{{ evidence.evidenceData[index]['title']}}：</span>
							<span class="text12 textcolor999" style="word-break: break-all;">
								{{evidence.evidenceData[index]['value']||'-'}}</span>
						</div>
					</div>
				</div>
				<div class="all_tips_content_card margin_top_10">
					<div class="text12 textcolorblack">区块链信息</div>
					<div class="margin_top_1">
						<span class="text12 textcolor999" style="display: inline-block; width: 30%;">长城链存证编号：</span>
						<span class="text12 textcolor999" style="word-break: break-all;">
							{{evidence.evidenceCode}}</span>
					</div>
					<div class="margin_top_1">
						<span class="text12 textcolor999" style="display: inline-block; width: 30%;">长城链存证时间：</span>
						<span class="text12 textcolor999" style="word-break: break-all;">
							{{Tool.dateFormate(evidence.evidenceTime)||'-'}}</span>
					</div>
					<div class="margin_top_1">
						<span class="text12 textcolor999" style="display: inline-block; width: 30%;">长城链区块高度：</span>
						<span class="text12 textcolor999" style="word-break: break-all;">
							{{evidence.evidenceBch}}</span>
					</div>
					<div class="margin_top_1" v-if="evidence.attrs&&evidence.attrs.txCode">
						<span class="text12 textcolor999" style="display: inline-block; width: 30%;">天平链存证编号：</span>
						<span class="text12 textcolor999" style="word-break: break-all;">
							{{evidence.attrs.txCode ||'-' }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
	</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	export default {
		data() {
			return {
				//1  存证文档查验 0 存证编号查验
				type: '-1', // 
				//存证编号
				evidenceCode: '',
				//
				corpId: '',
				//
				certId: '',
				//
				evidence: null,
				//
				evidenceKeys: null,
				//
				certificateVerificationInfo: this.$store.state.certificateVerificationInfo,
			}
		},
		mounted() {
			this.init()
		},
		beforeDestroy() {
			this.$store.commit("changeCertVerifInfo", '')
		},
		methods: {
			//初始化
			init() {
				this.type = this.$route.query.type;
				this.evidenceCode = this.$route.query.evidenceCode
				this.corpId = this.$route.query.corpId
				this.certId = this.$route.query.certId
				if (this.evidenceCode) {
					this.getEvidenceData()
				} else if (this.corpId) {
					this.getCorpEvidenceData()
				} else if (this.certId) {
					this.getCertEvidenceData()
				}
				// console.log(this.$store.state.certificateVerificationInfo)
				// console.log(typeof this.type)
				// for (let item in this.$store.state.certificateVerificationInfo
				// 		.bcResult.upload) {
				// 	console.log(item)
				// }
			},
			//
			getEvidenceData(code) {
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/evidence/api/getEvidence', {
					code: this.evidenceCode,
				}).then(res => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.evidence = res.data
						this.evidenceKeys = Object.keys(res.data.evidenceData)
					} else {
						this.$Toast(res.message || res.messageDetail || '未获取到存证信息')
					}
				}).catch(err => {
					this.$store.dispatch(this.$LoadShow, false)
					console.log('/evidence/api/getEvidence', err)
				})
			},
			//
			getCorpEvidenceData() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/evidence/api/getCorpEvidence', {
					corpId: this.evidenceCode,
				}).then(res => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.evidence = res.data
						this.evidenceKeys = Object.keys(res.data.evidenceData)
					} else {
						this.$Toast(res.message || res.messageDetail || '未获取到存证信息')
					}
				}).catch(err => {
					this.$store.dispatch(this.$LoadShow, false)
					console.log('/evidence/api/getCorpEvidence', err)
				})
			},
			//
			getCertEvidenceData() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/evidence/api/getCertEvidence', {
					certId: this.evidenceCode,
				}).then(res => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.evidence = res.data
						this.evidenceKeys = Object.keys(res.data.evidenceData)
					} else {
						this.$Toast(res.message || res.messageDetail || '未获取到存证信息')
					}
				}).catch(err => {
					this.$store.dispatch(this.$LoadShow, false)
					console.log('/evidence/api/getCertEvidence', err)
				})
			},
			//
			getFileInfo() {
				console.log(JSON.parse(this.$store.state.certificateVerificationInfo))
				let info = JSON.parse(this.$store.state.certificateVerificationInfo)
				for (let item in info) {
					console.log(info[item].title)
					console.log(info[item].value)
				}
				return JSON.parse(this.$store.state.certificateVerificationInfo)
			}
		},
	}
</script>


<style scoped lang="scss">
	@import "../../styles/global.css";
</style>